export function getInitialColumns(
  savedColumns: string | null,
  defaultColumns: string[]
): string[] {
  return savedColumns === null ? defaultColumns : JSON.parse(savedColumns);
}

export function getColumnEditorConfig(_variant: 'simplified') {
  return {
    title: 'Editar colunas',
    description: 'Selecione as informações que deseja visualizar na tabela.',
    sectionTitle: 'Colunas visíveis',
    columns: [
      'Ativo',
      'Data',
      'Tipo',
      'Corretora',
      'Quantidade',
      'Valor por cota',
      'Valor total',
    ],
    showLegacyGroups: false,
    showWarning: false,
  };
}

const PROCEEDS_RECEIVED_COLUMNS = [
  'Ativo',
  'Data',
  'Tipo',
  'Corretora',
  'Quantidade',
  'Valor por cota',
  'Valor total',
];

export function migrateProceedsReceivedColumns(columns: string[]): string[] {
  const migratedColumns = columns.flatMap((column) => {
    if (column === 'Preço') return ['Valor por cota'];
    if (column === 'Valor por cota' || column === 'Total por cota') {
      return ['Valor total'];
    }
    return [column];
  });

  return PROCEEDS_RECEIVED_COLUMNS.filter((column) =>
    migratedColumns.includes(column)
  );
}
